import * as React from 'react';
import { Box, Flex, FlexProps, Link } from '@qga/roo-ui/components';
import styled from '@emotion/styled';
import { useBookingList } from 'pages/BookingListPage/BookingListProvider';
import useNavigateTo from 'hooks/useNavigateTo';

const FlexLink = (props: FlexProps) => <Flex {...props} />;

const StyledLink = styled(Link)`
  color: inherit;
  text-decoration: none;
`;

StyledLink.displayName = 'StyledLink';

interface InfoWrapperProps extends React.PropsWithChildren<any> {
  bookingId: string;
  [key: string]: any;
}

export const InfoWrapper = ({ bookingId, children, ...rest }: InfoWrapperProps) => {
  const { sendViewBookingEvent } = useBookingList();
  const navigateTo = useNavigateTo();

  const goToBookingDetails = () => {
    sendViewBookingEvent(bookingId);
    navigateTo.booking('push', bookingId);
  };

  return (
    <Box px={[4, 5]} width="100%">
      <FlexLink as={StyledLink} onClick={goToBookingDetails} flexDirection="column" {...rest}>
        {children}
      </FlexLink>
    </Box>
  );
};
